var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",staticStyle:{"height":"100vh"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('img',{staticClass:"mb-4",attrs:{"src":"/assets/images/golia-powered-by.png","height":"80"}})])
}]

export { render, staticRenderFns }